import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import frameLayoutStyles from './frame-layout.module.scss';
import { MessageFrame } from './MessageFrame';
import { MessageItems } from './MessageItems';
import { ProposalActionsRow } from './ProposalActionsRow';
import { ProposalItemCheckbox } from './ProposalItemCheckbox';
export const GetListSelectMultiMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ListSelectMultiMessage = (param)=>{
    let { content, messageId, interactive, onDismiss, onApply, frameClassName, floating, scrollable } = param;
    const { ListSelectMultiMessageTID } = useMemo(()=>GetListSelectMultiMessageTID(messageId), [
        messageId
    ]);
    const [itemChecked, setItemChecked] = useState(()=>{
        const initial = {};
        content.items.forEach((i)=>initial[i.id] = i.checked);
        return initial;
    });
    const toggleItem = (itemId)=>setItemChecked((prev)=>_object_spread_props(_object_spread({}, prev), {
                [itemId]: !prev[itemId]
            }));
    const selectedItemIds = content.items.map((i)=>i.id).filter((id)=>itemChecked[id]);
    return /*#__PURE__*/ _jsx(Column, {
        gap: 12,
        width: "100%",
        className: frameLayoutStyles.fillSlot,
        children: /*#__PURE__*/ _jsxs(MessageFrame, {
            testId: ListSelectMultiMessageTID.Root(),
            padding: "16px 0 0 0",
            fillHeight: true,
            className: frameClassName,
            floating: floating,
            scrollable: scrollable,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: ListSelectMultiMessageTID.Intro(),
                    className: frameLayoutStyles.framePad,
                    showWhiteSpaces: true,
                    applyMarkdownBold: true,
                    children: content.intro
                }),
                content.question !== content.intro && /*#__PURE__*/ _jsx(Typography, {
                    testId: ListSelectMultiMessageTID.Question(),
                    className: frameLayoutStyles.framePad,
                    showWhiteSpaces: true,
                    applyMarkdownBold: true,
                    children: content.question
                }),
                /*#__PURE__*/ _jsx(MessageItems, {
                    testId: ListSelectMultiMessageTID.Items(),
                    gap: 8,
                    padBottom: false,
                    children: content.items.map((item)=>/*#__PURE__*/ _jsx(ProposalItemCheckbox, {
                            item: item,
                            checked: !!itemChecked[item.id],
                            disabled: !interactive,
                            onChange: ()=>toggleItem(item.id),
                            testId: ListSelectMultiMessageTID.Item(item.id)
                        }, item.id))
                }),
                interactive && /*#__PURE__*/ _jsx(ProposalActionsRow, {
                    className: frameLayoutStyles.frameFooter,
                    selectedCount: selectedItemIds.length,
                    applySelectedLabel: content.addSelectedLabel,
                    dismissLabel: content.dismissLabel,
                    applySelectedDisabled: selectedItemIds.length === 0,
                    onApplySelected: ()=>onApply(messageId, selectedItemIds),
                    onDismiss: ()=>onDismiss(messageId),
                    dismissTestId: ListSelectMultiMessageTID.Dismiss(),
                    applySelectedTestId: ListSelectMultiMessageTID.AddSelected()
                })
            ]
        })
    });
};
